/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'

import CRM from '../BaseComponent/CRM'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class ReportPriority extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      priorityTypes: [],
      printInfo: [],
      deleteModal: false,
      editModal: false,
      priorityName: '',
      priorityEnable: '',
      priorityId: ''
    }
  }

  callReportPriority = () => {
    http.get(`${CRM.CRM_CONTACT_PRIORITY_REPORT}`, {}).then((response) => {
      if (response.data.error == null) {
        // alert(JSON.stringify(response.data))
        this.setState({
          priorityTypes: response.data.object.result,
          total: response.data.object.countAll
        })
      } else {
        this.setState({
          priorityTypes: []
        })
      }
    })
  }

  componentDidMount() {
    this.callReportPriority()
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      priorityTypes: data
    })
  }

  changeDropDown(data) {
    this.setState({
      priorityTypes: data,
      lengthProducts: this.state.total
    })
  }

  deletepriority = (id, name) => {
    sessionStorage.setItem('priorityId', id)
    this.setState({
      deleteModal: !this.state.deleteModal,
      priorityName: name
    })
  }
  toggleDelete = () => {
    sessionStorage.removeItem('priorityId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      priorityName: ''
    })
  }
  deleteCancel = () => {
    sessionStorage.removeItem('priorityId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      priorityName: ''
    })
  }
  deleteOk = () => {
    let contactPriorityId = sessionStorage.getItem('priorityId')
    let data = {
      contactPriorityId
    }
    http.post(`${CRM.CRM_CONTACT_PRIORITY_REMOVE}`, data, {}).then((response) => {
      if (response.data.error == null) {
        message.success('اولویت با موفقیت حذف شد')
        this.deleteCancel()
        this.callReportPriority()
      } else {
        message.error(response.data.description)
      }
    })
  }

  editpriority = (id, name, enable) => {
    this.setState({
      editModal: !this.state.editModal,
      priorityId: id,
      priorityName: name,
      priorityEnable: enable
    })
  }
  editCancel = () => {
    this.setState({
      editModal: !this.state.editModal,
      priorityId: '',
      priorityName: '',
      priorityEnable: ''
    })
  }
  toggleEdit = () => {
    this.editCancel()
  }
  editOk = () => {
    var name = document.getElementById('name').value
    var enabled = document.getElementById('enabled').value
    let data = {
      name,
      enabled,
      contactPriorityId: this.state.priorityId
    }
    http.post(`${CRM.CRM_CONTACT_PRIORITY_UPDATE}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('ویرایش با موفقیت انجام شد')
        this.editCancel()
        this.callReportPriority()
      } else {
        message.error(response.data.description)
      }
    })
  }

  exportExcel = () => {
    http
      .get(
        `${CRM.CRM_CONTACT_PRIORITY_REPORT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${CRM.CRM_CONTACT_PRIORITY_REPORT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = ['ردیف', 'عنوان', 'وضعیت']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="ارتباط با مشتری - اولویت های تماس"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((media, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{media.contactPriorityName}</td>
                  <td>{media.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="ارتباط با مشتری - اولویت های تماس.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'contactPriorityName'}
                field={'contactPriorityName'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>ارتباط با مشتری</li>
            <li>اولویت ها</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/addpriority"
                  url={CRM.CRM_CONTACT_PRIORITY_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={CRM.CRM_CONTACT_PRIORITY_REPORT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />

                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>عنوان</td>
                    <td>وضعیت فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>

                  {this.state.priorityTypes.map((priority, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{priority.contactPriorityName}</td>
                      <td>
                        {priority.enabled ? (
                          <img src={require('../../image/confirm.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/ignor.svg')} alt="" />
                        )}
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.editpriority(
                              priority.contactPriorityId,
                              priority.contactPriorityName,
                              priority.enabled
                            )
                          }
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => this.deletepriority(priority.contactPriorityId, priority.contactPriorityName)}
                        >
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.total}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={CRM.CRM_CONTACT_priority_REPORT}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.deleteModal} toggle={this.toggleDelete} size="sm">
          <ModalHeader toggle={this.toggleDelete}>حذف اولویت</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف اولویت {this.state.priorityName} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف اولویت
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.toggleEdit} size="sm">
          <ModalHeader toggle={this.toggleEdit}>حذف اولویت</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label> نام اولویت: </label>
                <input className="form-control" type="text" defaultValue={this.state.priorityName} id="name" />
              </div>
              <div className="formComponent">
                <label> وضعیت اولویت: </label>

                <select className="form-control" name="enabled" id="enabled">
                  <option selected={this.state.priorityEnable == 1 ? true : false} value={1}>
                    فعال
                  </option>
                  <option selected={this.state.priorityEnable == 0 ? true : false} value={0}>
                    غیر فعال
                  </option>
                </select>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش اولویت
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ReportPriority
